import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	edit: {
		id: 'eoc.routing-rules.ui.rule-card-actions.edit.no-translate',
		defaultMessage: 'Edit',
		description: 'Label of edit button',
	},
	clone: {
		id: 'eoc.routing-rules.ui.rule-card-actions.clone.no-translate',
		defaultMessage: 'Duplicate',
		description: 'Label of clone button',
	},
	delete: {
		id: 'eoc.routing-rules.ui.rule-card-actions.add.no-translate',
		defaultMessage: 'Delete',
		description: 'Label of delete button',
	},
	showMore: {
		id: 'eoc.routing-rules.ui.rule-card-actions.show-more.no-translate',
		defaultMessage: 'Show Actions of {name}',
		description: 'Label of show more button',
	},
	routeTargetDeleted: {
		id: 'eoc.routing-rules.ui.rule-card-actions.route-target-deleted.no-translate',
		defaultMessage: 'Route Target Deleted',
		description: 'Label of route target deleted lozenge',
	},
});

export default messages;
